// extracted by mini-css-extract-plugin
export default {"button":"ButtonPrimary_button__OB+sf"};